import React from 'react';
import { CSVLink } from 'react-csv';
import { Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

interface ExportToCSVProps {
  data: any[];
  headers?: any[];
  fileName: string;
}

const ExportToCSV: React.FC<ExportToCSVProps> = ({ data, headers, fileName }) => {
  return (
    <Tooltip title="Download Excel">
      <CSVLink data={data} headers={headers} filename={fileName}>
        <DownloadOutlined />
      </CSVLink>
    </Tooltip>
  );
};

export default ExportToCSV;
